import { Sparkle } from "lucide-react";

/** The AI's avatar in a chat thread: the design's sparkle on the brand tint. */
export function AssistantAvatar() {
  return (
    <span
      aria-hidden="true"
      className="grid size-7 shrink-0 place-items-center rounded-full bg-brand-primary-subtle text-brand-primary-on-subtle"
    >
      <Sparkle size={14} />
    </span>
  );
}
